import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content1" }
const _hoisted_2 = { class: "order-message" }
const _hoisted_3 = { class: "content_list_item_top" }
const _hoisted_4 = { class: "content_list_item_top_left" }
const _hoisted_5 = { class: "content_list_item_top_right" }
const _hoisted_6 = {
  key: 0,
  class: "warning"
}
const _hoisted_7 = {
  key: 1,
  class: "green"
}
const _hoisted_8 = {
  key: 2,
  class: "info"
}
const _hoisted_9 = { class: "content_list_item_content" }
const _hoisted_10 = {
  style: {"margin-top":"0"},
  class: "content_list_item_content_item"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "单据类型：", -1)
const _hoisted_12 = { class: "content_list_item_content_item_nr" }
const _hoisted_13 = { class: "content_list_item_content_item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "出货仓库：", -1)
const _hoisted_15 = { class: "content_list_item_content_item_nr" }
const _hoisted_16 = { class: "content_list_item_content_item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划日期：", -1)
const _hoisted_18 = { class: "content_list_item_content_item_nr" }
const _hoisted_19 = { class: "content_list_item_content_item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "来源类型：", -1)
const _hoisted_21 = { class: "content_list_item_content_item_nr" }
const _hoisted_22 = { class: "content_list_item_content_item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "来源单号：", -1)
const _hoisted_24 = { class: "content_list_item_content_item_nr" }
const _hoisted_25 = {
  key: 0,
  class: "content_list_item_content_item"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "操作人：", -1)
const _hoisted_27 = { class: "content_list_item_content_item_nr" }
const _hoisted_28 = {
  key: 1,
  class: "content_list_item_content_item"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "操作时间：", -1)
const _hoisted_30 = { class: "content_list_item_content_item_nr" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "title-prefix" }, null, -1)
const _hoisted_33 = { class: "material-content" }
const _hoisted_34 = { class: "item-title-style" }
const _hoisted_35 = { style: {"font-weight":"500"} }
const _hoisted_36 = { class: "item-content-style" }
const _hoisted_37 = { class: "content_list_item_content_item" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "批次号：", -1)
const _hoisted_39 = { class: "content_list_item_content_item_nr" }
const _hoisted_40 = { class: "content_list_item_content_item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "数量：", -1)
const _hoisted_42 = { class: "content_list_item_content_item_nr" }
const _hoisted_43 = { class: "content_list_item_content_item" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "工序：", -1)
const _hoisted_45 = { class: "content_list_item_content_item_nr" }
const _hoisted_46 = { class: "content_list_item_content_item" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "质量：", -1)
const _hoisted_48 = { class: "content_list_item_content_item_nr" }
const _hoisted_49 = {
  key: 0,
  class: "green"
}
const _hoisted_50 = {
  key: 1,
  class: "yellow"
}
const _hoisted_51 = {
  key: 2,
  class: "red"
}
const _hoisted_52 = { key: 3 }
const _hoisted_53 = { class: "content_list_item_content_item" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "出库货位：", -1)
const _hoisted_55 = { class: "content_list_item_content_item_nr" }
const _hoisted_56 = {
  key: 0,
  style: {"height":"94px"}
}
const _hoisted_57 = {
  key: 1,
  class: "bottom-button"
}

import { onMounted, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getBoundDetail, cancelBound } from '@/apis/materialStorage'
import { Toast } from 'vant'
import { orderTyepToStr } from '@/constData'

interface boundlDetail {
  materialName: string,
  materialCode: string,
  batch: string,
  num: number,
  locationName: number
}

interface TransferDetailModel {
  code: string;
  createName: string;
  planDate: string;
  dealDate: string;
  status: number;
  originType: number;
  originCode: string;
  updateName: string;
  updateMobile: string;
  updateTime: string;
  warehouseName: string;
  warehouseCode: string;
  outPlandate: string;
  inPlandate: string;
  woutboundDetailsWait: Array<boundlDetail> // 待出库
  woutboundDetailsOut: Array<boundlDetail> // 已出库
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const data = ref<TransferDetailModel>(
  {
    code: "",
    createName: "",
    planDate: "",
    dealDate: "",
    status: 0,
    originType: 0,
    originCode: "",
    updateName: "",
    updateMobile: "",
    updateTime: "",
    warehouseName: "",
    warehouseCode: "",
    outPlandate: "",
    inPlandate: "",
    woutboundDetailsWait: [],
    woutboundDetailsOut: []
  }
)
// 来源单据类型  0采购订单、1生产工单、2销售订单、3转库单、4盘点单
let types: Array<{name: string, id: string, isActive: boolean }> = reactive(
  [
    { name: '全部', id: '', isActive: true },
    { name: '采购订单', id: '0', isActive: false },
    { name: '生产工单', id: '1', isActive: false },
    { name: '销售订单', id: '2', isActive: false },
    { name: '转库单', id: '3', isActive: false },
    { name: '盘点单', id: '4', isActive: false },
  ]
)

let materailArray: Array<boundlDetail> = reactive([])

onMounted(() => {
  getBoundDetail({ id: route.query.id })
    .then(res => {
      data.value = res.data
      console.log(data.value)
      if (data.value.status === 1) {
        materailArray.push(...data.value.woutboundDetailsOut)
      } else {
        materailArray.push(...data.value.woutboundDetailsWait)
      }
      console.log(materailArray)
    })
})

const tyepToStr = (type: number): string => {
  //  <!-- 1、车间领料；2、车间备料；3、其他；4、完工入库 -->
  for (const item of types) {
    if (parseInt(item.id) === type) {
      return item.name
    }
  }
  return '-'
}

const submit = (): void => {

}
const cancel = (): void => {
  cancelBound({ id: route.query.id })
    .then(res => {
      console.log(res)
      Toast.success('取消成功')
      router.back()
    })
    .catch(err => {
      Toast.fail(err.message)
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(data.value.code), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (data.value.status === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "待出库"))
            : (data.value.status === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "已出库"))
              : (data.value.status === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已取消"))
                : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(orderTyepToStr)(data.value.billType)), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(data.value.warehouseCode + ' | ' + data.value.warehouseName), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(data.value.planDate), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, _toDisplayString(tyepToStr(data.value.originType)), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, _toDisplayString(data.value.originCode ? data.value.originCode : '-'), 1)
        ]),
        (data.value.updateName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, _toDisplayString(data.value.updateName + ' - ' + data.value.updateMobile), 1)
            ]))
          : _createCommentVNode("", true),
        (data.value.updateTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, _toDisplayString(data.value.updateTime), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _hoisted_32,
      _createElementVNode("span", null, _toDisplayString(data.value.status==1 ? '已出库物料' : '待出库物料'), 1)
    ]),
    _createElementVNode("div", _hoisted_33, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(materailArray), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item-style",
          key: index
        }, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("span", _hoisted_35, _toDisplayString(item.materialName + ' | ' + item.materialCode), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, _toDisplayString(item.batch), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, _toDisplayString(item.num + item.unitName), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, _toDisplayString(item.procedureName || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                (item.qualityType==0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "合格"))
                  : (item.qualityType==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, "不良"))
                    : (item.qualityType==2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, "报废"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_52, "-"))
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, _toDisplayString(item.locationName), 1)
            ])
          ])
        ]))
      }), 128))
    ]),
    (data.value.status === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_56))
      : _createCommentVNode("", true),
    (data.value.status === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("button", {
            class: "button button-action",
            onClick: submit
          }, "去出库"),
          _createElementVNode("button", {
            class: "button button-cancel",
            onClick: cancel
          }, "取消")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})